// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdOutlinePictureAsPdf } from 'react-icons/md';
import PostItem from "./PostItem";
import PostingModal from "./components/PostingModal";
import { Avatar } from "../../reusable/components/avatar";
import { Modal, Button } from "../../reusable";
import { SpotIllustrations } from "../../reusable/assets/svgs";
import { } from "./Icons";
import { collection, query, orderBy, limit, getDocs, where } from "firebase/firestore";
import { db } from "../../config/firebase-config";
import dummyPostsData from "../../data/dummyPosts.json";
import { useCreator, useUser, useAlerts, usePremiumDesigners } from "../../backend/hooks";
import { useFeed, useCreatePost } from "../../backend/hooks/feed/useFeed";
import "./Feed.css";
import "../blog/BlogPage.css";

// TabNav component for animated indicator
const TAB_KEYS: Array<'newest' | 'trending'> = ['newest', 'trending'];
interface TabNavProps {
  selectedView: 'newest' | 'trending' | 'myposts' | 'following';
  setSelectedView: React.Dispatch<React.SetStateAction<'newest' | 'trending' | 'myposts' | 'following'>>;
}
function TabNav({ selectedView, setSelectedView }: TabNavProps) {
  const [hovered, setHovered] = useState<'newest' | 'trending' | null>(null);

  return (
    <div className="feed-nav-tabs">
      {TAB_KEYS.map((key) => (
        <button
          key={key}
          className={`nav-tab ${selectedView === key ? 'active' : ''} ${hovered === key ? 'hovered' : ''}`}
          onClick={() => setSelectedView(key)}
          onMouseEnter={() => setHovered(key)}
          onMouseLeave={() => setHovered(null)}
        >
          {key.charAt(0).toUpperCase() + key.slice(1)}
        </button>
      ))}
    </div>
  );
}

// Unified categories for both left panel and drafting modal
export const FEED_CATEGORIES = [
  { value: 'residential', label: 'Residential' },
  { value: 'commercial', label: 'Commercial' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'furniture', label: 'Furniture & Decor' },
  { value: 'landscape', label: 'Landscape' },
  { value: 'renovation', label: 'Renovation' },
  { value: 'modern', label: 'Modern' },
  { value: 'traditional', label: 'Traditional' },
  { value: 'sustainable', label: 'Sustainable Design' },
  { value: 'materials', label: 'Materials' }
];


export interface MediaFile {
  file: File | undefined | null;
  type: 'image' | 'video' | 'pdf';
  preview: string;
}

interface LinkPreview {
  title: string;
  description: string;
  url: string;
  image?: string | null;
  source?: string;
}

export interface Post {
  id: string;
  user: string;
  username: string;
  userId?: string; // Add userId to Post interface
  profilePicture?: string; // Add profilePicture field
  tag: string;
  content: string;
  timestamp: string;
  media?: MediaFile[];
  linkPreview?: LinkPreview;
  likes: number;
  comments: number;
  reposts: number;
  userRole?: 'Business Owner' | 'Employee' | 'Student';
  affiliation?: string;
  commentsList?: Array<{
    id: number;
    profilePicture: string;
    author: string;
    timestamp: string;
    text: string;
    likes: number;
  }>;
}



const FiltersContent = ({
  selectedView,
  setSelectedView,
  selectedCategory,
  setSelectedCategory,
  setSearchQuery,
  setSelectedPostId,
  setActiveCommentPostId,
  posts,
  onFilterClick,
  isLoggedIn,
  followingCount
}: {
  selectedView: string;
  setSelectedView: any;
  selectedCategory: string;
  setSelectedCategory: any;
  setSearchQuery: any;
  setSelectedPostId: any;
  setActiveCommentPostId: any;
  posts: Post[];
  onFilterClick?: () => void;
  isLoggedIn: boolean;
  followingCount: number;
}) => (
  <>
    <div className="feed-filters">
      <h3 className="filter-title">Activity Stream Filters</h3>
      <div className="filter-options">
        <button 
          className={`filter-btn ${selectedView === 'newest' && selectedCategory === 'all' ? 'active' : ''}`}
          onClick={() => {
            setSelectedView('newest');
            setSelectedCategory('all');
            setSelectedPostId(null);
            setActiveCommentPostId(null);
            if (onFilterClick) onFilterClick();
          }}
        >
          All Posts
        </button>
        <button 
          className={`filter-btn ${selectedView === 'myposts' ? 'active' : ''}`}
          style={{ 
            opacity: isLoggedIn ? 1 : 0.5, 
            cursor: isLoggedIn ? 'pointer' : 'not-allowed',
            pointerEvents: isLoggedIn ? 'auto' : 'none'
          }}
          onClick={() => {
            if (!isLoggedIn) return;
            setSelectedView('myposts');
            setSelectedCategory('all');
            setSearchQuery('');
            setSelectedPostId(null);
            setActiveCommentPostId(null);
            if (onFilterClick) onFilterClick();
          }}
          disabled={!isLoggedIn}
        >
          My Posts
        </button>
        <button 
          className={`filter-btn ${selectedView === 'following' ? 'active' : ''}`}
          style={{ 
            opacity: isLoggedIn ? 1 : 0.5, 
            cursor: isLoggedIn ? 'pointer' : 'not-allowed',
            pointerEvents: isLoggedIn ? 'auto' : 'none'
          }}
          onClick={() => {
            if (!isLoggedIn) return;
            setSelectedView('following');
            setSelectedCategory('all');
            setSearchQuery('');
            setSelectedPostId(null);
            setActiveCommentPostId(null);
            if (onFilterClick) onFilterClick();
          }}
          disabled={!isLoggedIn}
        >
          Following{isLoggedIn ? ` (${followingCount})` : ''}
        </button>
      </div>
    </div>

    <div className="featured-categories-section">
      <h3 className="trending-title">Popular Categories</h3>
      <div className="category-tags">
        {FEED_CATEGORIES.slice(0, 8)
          .filter(cat => {
            const categoryCount = posts.filter(post => post.tag === cat.value).length;
            return categoryCount > 0;
          })
          .map(cat => {
            const categoryCount = posts.filter(post => post.tag === cat.value).length;
            return (
              <button 
                key={cat.value} 
                className={`category-tag ${selectedCategory === cat.value ? 'active' : ''}`}
                onClick={() => {
                  setSelectedCategory(cat.value);
                  setSelectedView('newest');
                  setSearchQuery('');
                  setSelectedPostId(null);
                  setActiveCommentPostId(null);
                  if (onFilterClick) onFilterClick();
                }}
              >
                {cat.label} ({categoryCount})
              </button>
            );
          })}
      </div>
    </div>
  </>
);

const FeedScreen: React.FC = () => {
  const navigate = useNavigate();
  const { creatorProfile, getProfile } = useCreator();
  const { loggedInUser, followUser, unfollowUser, getFollowingIds } = useUser();
  const { addAlert } = useAlerts();

  // Fetch creator profile on mount if not already loaded
  useEffect(() => {
    if (!creatorProfile && loggedInUser?.userId) {
      getProfile(loggedInUser.userId);
    }
  }, [loggedInUser?.userId, creatorProfile, getProfile]);
  const currentUserName = creatorProfile ? `${creatorProfile.firstName} ${creatorProfile.lastName}` : (loggedInUser?.name || "You");
  
  const getAvatarUrl = (pic: any) => {
    if (Array.isArray(pic)) return pic[0] || "";
    return pic || "";
  };

  const currentUserAvatar = getAvatarUrl(creatorProfile?.profilePicture) || 
                           getAvatarUrl(loggedInUser?.profilePicture) || 
                           getAvatarUrl(loggedInUser?.profilePhotoUrl) || 
                           "";
  
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(false); // Managed explicitly or derived
  const [error] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [showPostModal, setShowPostModal] = useState(false);
  const [selectedView, setSelectedView] = useState<'newest' | 'trending' | 'myposts' | 'following'>('newest');
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [postingModalAction, setPostingModalAction] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  

  // Backend Hooks
  const [followingIds, setFollowingIds] = useState<string[]>([]);
  const { posts: backendPosts, loading: backendLoading, deletePost: deleteBackendPost, refresh } = useFeed(
    selectedCategory === 'all' ? 'all' : selectedCategory,
    selectedView === 'following' ? followingIds : undefined
  );
  const { createPost: createBackendPost } = useCreatePost();
  const { designers: fetchedDesigners } = usePremiumDesigners(5);
  
  // Delete modal state
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [postToDelete, setPostToDelete] = useState<string | null>(null);

  // Sync backend posts to local state with formatting
  useEffect(() => {
    if (backendPosts) {
      const formattedPosts: Post[] = backendPosts.map((p: any) => ({
        id: p.id,
        user: p.user,
        username: p.username,
        userId: p.userId,
        profilePicture: p.profilePicture || p.userProfilePicture || p.profilePhotoUrl || p.avatar,
        tag: p.tag,
        title: p.title,
        content: p.content,
        // Format timestamp relative time (simplified)
        timestamp: p.timestamp && p.timestamp.seconds ? (() => {
           const diff = Date.now() / 1000 - p.timestamp.seconds;
           if (diff < 60) return 'Just now';
           if (diff < 3600) return `${Math.floor(diff / 60)}m`;
           if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
           return `${Math.floor(diff / 86400)}d`;
        })() : 'Just now',
        media: p.media ? p.media.map((m: any) => ({ 
          file: null, 
          type: m.type, 
          preview: m.preview || m.url 
        })) : undefined,
        likes: p.likes || 0,
        comments: p.comments || 0,
        reposts: p.reposts || 0,
        userRole: p.userRole,
        affiliation: p.affiliation,
        linkPreview: p.linkPreview
      }));
      
      // Map for dummy data company names
      const companyNames: Record<string, string> = {
        "sarah_designs": "Sarah Residential Designs",
        "alexchen_studio": "Alex Chen Studio",
        "maya_interiors": "Maya Interiors",
        "david_builds": "David Builds Inc.",
        "emma_creative": "Emma Creative",
        "james_minimalist": "JP Minimalist",
        "lisa_luxury": "Lisa Luxury Design",
        "mike_industrial": "Mike Industrial",
        "rachel_botanical": "Botanical Designs",
        "carlos_eclectic": "Eclectic Studios",
        "nina_wellness": "Nina Wellness",
        "tom_smart_home": "Smart Home Solutions",
        "bella_colors": "Bella Colors",
        "kevin_outdoors": "Outdoors & More",
        "hannah_vintage": "Vintage Revival",
        "ryan_workspace": "Workspace Pros",
        "sophia_budget": "Budget Décor",
        "marcus_hospitality": "Hospitality Group",
        "zoe_textures": "Texture Labs",
        "adrian_future": "Future Living"
      };

      const dummyPosts: Post[] = (dummyPostsData as any[]).map(d => ({
        id: d.id,
        user: d.user,
        username: d.username,
        profilePicture: d.username === 'maya_interiors' ? '/sample/luxury-bedroom-hotel.jpg' : 
                d.username === 'david_builds' ? '/sample/modern-architecture.jpg' : 
                d.username === 'sarah_designs' ? '/sample/kitchen.jpg' :
                d.username === 'alexchen_studio' ? '/sample/business-concept-with-time-word-wooden-cubes-hourglass-plant 1.png' : "",
        tag: d.tag,
        content: d.content,
        timestamp: d.timestamp,
        media: d.media ? d.media.map((m: any) => ({
          file: null,
          type: m.type,
          preview: m.preview
        })) : undefined,
        likes: d.likes,
        comments: d.comments,
        reposts: d.reposts,
        userRole: d.userRole as any,
        affiliation: d.affiliation || companyNames[d.username] || "Design Professional",
        linkPreview: d.linkPreview
      }));

      setPosts([...dummyPosts, ...formattedPosts]);
      setLoading(backendLoading);
    }
  }, [backendPosts, backendLoading]);

  // Comment modal state
  const [activeCommentPostId, setActiveCommentPostId] = useState<string | null>(null);
  
  // Create post box state
  const [createPostContent, setCreatePostContent] = useState('');
  const [createPostMedia, setCreatePostMedia] = useState<MediaFile[]>([]);
  const createPostFileInputRef = React.useRef<HTMLInputElement>(null);
  const createPostVideoInputRef = React.useRef<HTMLInputElement>(null);
  const createPostPdfInputRef = React.useRef<HTMLInputElement>(null);

  // Featured jobs state
  interface FeaturedJob {
    id: string;
    title: string;
    company: string;
    location: string;
    logo: string;
    type: string;
    posted: string;
  }
  const [featuredJobs, setFeaturedJobs] = useState<FeaturedJob[]>([]);

  // Staff-Picked Designers state
  interface StaffPickedDesigner {
    id: string;
    name: string;
    description: string;
    avatar: string;
    username: string;
  }
  const [staffPickedDesigners, setStaffPickedDesigners] = useState<StaffPickedDesigner[]>([]);
  
  // Sync fetched designers to state
  useEffect(() => {
    setStaffPickedDesigners(fetchedDesigners);
  }, [fetchedDesigners]);

  useEffect(() => {
    let isMounted = true;
    const loadFollowingIds = async () => {
      if (!loggedInUser?.userId) {
        if (isMounted) setFollowingIds([]);
        return;
      }
      const ids = await getFollowingIds();
      if (isMounted) setFollowingIds(ids);
    };
    loadFollowingIds();
    return () => {
      isMounted = false;
    };
  }, [loggedInUser?.userId, getFollowingIds]);

  const handleToggleFollow = async (targetUserId?: string) => {
    if (!loggedInUser?.userId || !targetUserId || targetUserId === loggedInUser.userId) return;

    const isFollowing = followingIds.includes(targetUserId);
    if (isFollowing) {
      const ok = await unfollowUser(targetUserId);
      if (ok) {
        setFollowingIds(prev => prev.filter(id => id !== targetUserId));
      }
    } else {
      const ok = await followUser(targetUserId);
      if (ok) {
        setFollowingIds(prev => [...prev, targetUserId]);
      }
    }
  };

  // Helper function to format posted time
  const formatPostedTime = (timestamp: any) => {
    if (!timestamp) return '';
    const now = new Date();
    const createdAt = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    const diffMs = now.getTime() - createdAt.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return createdAt.toLocaleDateString();
  };

  // Fetch featured jobs from Firestore
  useEffect(() => {
    const fetchFeaturedJobs = async () => {
      try {
        const q = query(collection(db, "job-postings"), orderBy("createdAt", "desc"), limit(2));
        const snap = await getDocs(q);
        const jobs = snap.docs.map(doc => ({
          id: doc.id,
          title: doc.data().jobPosition || '',
          company: doc.data().companyName || '',
          location: (doc.data().jobLocation && doc.data().jobLocation.place) || '',
          logo: doc.data().profilePicture || '/favicon.svg',
          type: doc.data().jobType || '',
          posted: formatPostedTime(doc.data().createdAt)
        }));
        setFeaturedJobs(jobs);
      } catch (error) {
        console.error('Error fetching featured jobs:', error);
      }
    };

    fetchFeaturedJobs();
  }, []);

  // Fetch featured blogs from Firestore
  // featured blogs removed from right sidebar per design

  // Handle media selection in create post box
  const handleCreatePostMediaChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'image' | 'video' | 'pdf') => {
    const files = Array.from(e.target.files || []);
    let newMedia: MediaFile[] = [];
    files.forEach(file => {
      const isImage = file.type.startsWith('image/');
      const isVideo = file.type.startsWith('video/');
      const isPdf = file.type === 'application/pdf';
      if ((type === 'image' && isImage) || (type === 'video' && isVideo) || (type === 'pdf' && isPdf)) {
        if (type === 'pdf') {
          // 10MB size limit for PDF
          if (file.size > 10 * 1024 * 1024) {
            window.alert('PDF size must be 10MB or less.');
            return;
          }
          newMedia.push({ file, type, preview: '' });
          if (newMedia.length === files.length) {
            setCreatePostMedia(prev => {
              const combined = [...prev, ...newMedia];
              return combined.slice(0, 10);
            });
          }
        } else {
          const reader = new FileReader();
          reader.onloadend = () => {
            newMedia.push({
              file,
              type: type,
              preview: reader.result as string
            });
            if (newMedia.length === files.length) {
              setCreatePostMedia(prev => {
                const combined = [...prev, ...newMedia];
                return combined.slice(0, 10);
              });
            }
          };
          reader.readAsDataURL(file);
        }
      }
    });
    e.target.value = '';
  };

  // Removed bulleted list handler

  const handleOpenPostingModalWithContent = () => {
    // Open modal fresh when clicking input (no action, no prefill if empty)
    if (createPostContent || createPostMedia.length > 0) {
      setPostingModalAction('prefill');
    } else {
      setPostingModalAction(null);
    }
    setShowPostModal(true);
  };





  const handleAddPost = async (newPost: { user: string; content: string; title?: string; tag: string; media?: MediaFile[] }) => {
    try {
      addAlert({
        message: "Posting your update...",
        type: "info",
        autoHide: true
      });

      const mediaForUpload = newPost.media
        ? newPost.media
            .filter(m => m.file) // Ensure file exists
            .slice(0, 10) // Limit to 10
            .map(m => ({ file: m.file as File, type: m.type }))
        : [];

      // Determine user role and affiliation from profile
      const userRole = creatorProfile?.position || 'Business Owner';
      let affiliation = 'Kydoscope Interiors'; // Default backup

      if (creatorProfile) {
        if (creatorProfile.position === 'Student') {
          affiliation = creatorProfile.universityName || 'Design School';
        } else if (creatorProfile.companyName) {
           affiliation = creatorProfile.companyName;
        }
      }

      await createBackendPost(
        newPost.content,
        newPost.tag || 'general',
        newPost.title,
        mediaForUpload,
        undefined, // linkPreview
        userRole,
        affiliation
      );
      
      addAlert({
        message: "Post uploaded successfully!",
        type: "success",
        autoHide: true
      });

      refresh(); // Refresh feed to show new post
      setShowPostModal(false);
    } catch (error) {
      console.error("Failed to create post:", error);
      addAlert({
        message: "Failed to create post. Please try again.",
        type: "error",
        autoHide: true
      });
    }
  };

  const confirmDeletePost = (postId: string) => {
    setPostToDelete(postId);
    setShowDeleteModal(true);
  };

  const handleDeletePost = async () => {
    if (postToDelete) {
      try {
        await deleteBackendPost(postToDelete);
        if (selectedPostId === postToDelete) setSelectedPostId(null);
        if (activeCommentPostId === postToDelete) setActiveCommentPostId(null);
      } catch (error) {
        console.error("Failed to delete post:", error);
      }
    }
    setShowDeleteModal(false);
    setPostToDelete(null);
  };

  const filteredPosts = posts
    .filter(post => {
      // First apply search filter
      const matchesSearch = post.content.toLowerCase().includes(searchQuery.toLowerCase()) ||
        post.user.toLowerCase().includes(searchQuery.toLowerCase()) ||
        post.tag.toLowerCase().includes(searchQuery.toLowerCase());
      if (!matchesSearch) return false;
      
      // Apply category filter
      if (selectedCategory !== 'all') {
        if (post.tag !== selectedCategory) return false;
      }
      
      // Then apply view filter
      if (selectedView === 'myposts') {
        // Only show user's own posts
        return post.userId === loggedInUser?.userId || post.user === 'You' || post.user === currentUserName;
      }
      if (selectedView === 'following') {
        return !!post.userId && followingIds.includes(post.userId);
      }
      // 'newest' and 'trending' show all posts
      return true;
    })
    .sort((a, b) => {
      if (selectedView === 'newest') {
        // Sort by most recent first (assuming lower timestamp numbers = more recent)
        // Convert timestamp strings like "4m", "13m", "1h" to minutes for comparison
        const getMinutes = (timestamp: string) => {
          if (timestamp === 'Just now') return 0;
          const num = parseInt(timestamp);
          if (isNaN(num)) return 0; 
          if (timestamp.includes('h')) return num * 60;
          if (timestamp.includes('d')) return num * 24 * 60;
          return num; // assume minutes
        };
        return getMinutes(a.timestamp) - getMinutes(b.timestamp);
      } else if (selectedView === 'trending') {
        // Sort by engagement (likes + comments + reposts)
        const aEngagement = a.likes + a.comments + a.reposts;
        const bEngagement = b.likes + b.comments + b.reposts;
        return bEngagement - aEngagement; // Descending order (most engaging first)
      } else if (selectedView === 'myposts') {
        // Sort my posts by recency
        const getMinutes = (timestamp: string) => {
          if (timestamp === 'Just now') return 0;
          const num = parseInt(timestamp);
          if (isNaN(num)) return 0;
          if (timestamp.includes('h')) return num * 60;
          if (timestamp.includes('d')) return num * 24 * 60;
          return num;
        };
        return getMinutes(a.timestamp) - getMinutes(b.timestamp);
      }
      
      return 0; // Keep original order
    });

  return (
    <div className="feed-screen-wrapper">
      {/* Left Sidebar - Feed Navigation */}
      <div className="feed-sidebar">
        {/* Search Box */}
        <div className="sidebar-search">
          <input
            type="text"
            placeholder="Search posts..."
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            className="search-input"
          />
        </div>

        {/* Feed Filters */}
        <FiltersContent 
          selectedView={selectedView}
          setSelectedView={setSelectedView}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          setSearchQuery={setSearchQuery}
          setSelectedPostId={setSelectedPostId}
          setActiveCommentPostId={setActiveCommentPostId}
          posts={posts}
          isLoggedIn={!!loggedInUser}
          followingCount={followingIds.length}
        />
      </div>

      {/* Main Feed */}
      <div className="feed-container">
          <div className="feed-tabs-bar">
            {/* Mobile Filters - Now Displayed Directly */}
            <div className="mobile-filters-section visible-directly">
              <div className="mobile-filters-content">
                <FiltersContent 
                  selectedView={selectedView}
                  setSelectedView={setSelectedView}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  setSearchQuery={setSearchQuery}
                  setSelectedPostId={setSelectedPostId}
                  setActiveCommentPostId={setActiveCommentPostId}
                  posts={posts}
                  isLoggedIn={!!loggedInUser}
                  followingCount={followingIds.length}
                  onFilterClick={() => {}} // No need to close anything
                />
              </div>
            </div>
          </div>

          {/* Create Post Section - Shown if user is logged in */}
          {loggedInUser && (
            <div className="create-post-box">
              <div className="create-post-top">
                <Avatar 
                  url={currentUserAvatar} 
                  height="38px" 
                  width="38px" 
                  componentKey="feed-create-post-avatar" 
                  name={currentUserName} 
                />
                <input 
                  type="text"
                  className="create-post-input" 
                  placeholder="What are you building?"
                  onClick={handleOpenPostingModalWithContent}
                  readOnly
                />
              </div>
              
              <div className="create-post-bottom">
                <div className="create-post-icons">
                  <input
                    ref={createPostFileInputRef}
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => handleCreatePostMediaChange(e, 'image')}
                  />
                  <button className="create-action-btn" title="Add Image" onClick={() => createPostFileInputRef.current?.click()}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                      <circle cx="8.5" cy="8.5" r="1.5"></circle>
                      <polyline points="21 15 16 10 5 21"></polyline>
                    </svg>
                  </button>
                  <input
                    ref={createPostVideoInputRef}
                    type="file"
                    accept="video/*"
                    multiple
                    style={{ display: 'none' }}
                    onChange={(e) => handleCreatePostMediaChange(e, 'video')}
                  />
                  <button className="create-action-btn" title="Add Video" onClick={() => createPostVideoInputRef.current?.click()}>
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polygon points="23 7 16 12 23 17 23 7"></polygon>
                      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
                    </svg>
                  </button>
                  <input
                    ref={createPostPdfInputRef}
                    type="file"
                    accept="application/pdf"
                    style={{ display: 'none' }}
                    onChange={(e) => handleCreatePostMediaChange(e, 'pdf')}
                  />
                  <button className="create-action-btn" title="Attach PDF" onClick={() => createPostPdfInputRef.current?.click()}>
                    {/* @ts-ignore */}
                    <MdOutlinePictureAsPdf size={22} />
                  </button>
                </div>
                
                <button className="post-submit-btn" onClick={handleOpenPostingModalWithContent}>
                  Post
                </button>
              </div>
            </div>
          )}

          {loading && <div className="feed-loading">Loading posts...</div>}
          {error && <div className="feed-error">Error: {error}</div>}
          {filteredPosts.length === 0 && !loading && (
            <div style={{ textAlign: 'center', padding: '40px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <SpotIllustrations style={{ width: '200px', height: 'auto', marginBottom: '20px' }} />
              <p>
                {searchQuery ? 'No posts found matching your search.' : 'No posts yet. '}
                <strong>{searchQuery ? '' : 'Be the first to share your work!'}</strong>
              </p>
            </div>
          )}
          <div className="feed-list">
            {activeCommentPostId ? (
              (() => {
                const selectedPost = posts.find(p => p.id === activeCommentPostId)!;
                return (
                  <PostItem
                    key={activeCommentPostId}
                    post={selectedPost}
                    selected={true}
                    showCommentInput={true}
                    showComments={true}
                    onComment={() => setActiveCommentPostId(null)}
                    currentUserName={currentUserName}
                    onDelete={confirmDeletePost}
                    isFollowing={!!selectedPost.userId && followingIds.includes(selectedPost.userId)}
                    onToggleFollow={handleToggleFollow}
                  />
                );
              })()
            ) : (
              filteredPosts.map(post => (
                <PostItem
                  key={post.id}
                  post={post}
                  selected={selectedPostId === post.id}
                  showCommentInput={false}
                  showComments={false}
                  onComment={() => {
                    // Show only this post with comments
                    setActiveCommentPostId(post.id);
                  }}
                  currentUserName={currentUserName}
                  onDelete={confirmDeletePost}
                  isFollowing={!!post.userId && followingIds.includes(post.userId)}
                  onToggleFollow={handleToggleFollow}
                />
              ))
            )}
          </div>
        </div>

      {/* Right Sidebar */}
      <div className="feed-right-sidebar">
        {/* Featured Jobs Section */}
        <div className="blog-previews-section" style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px' }}>
          <h3 className="blog-previews-title">Featured Jobs</h3>
          <div className="similar-blogs-list">
            {featuredJobs.length > 0 ? (
              featuredJobs.slice(0, 2).map(job => (
                <div
                  key={job.id}
                  className="similar-blog-block"
                  onClick={() => navigate(`/jobs/${job.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="similar-blog-image-wrapper">
                    <img
                      className="similar-blog-image"
                      src={job.logo}
                      alt={job.company}
                      loading="lazy"
                      style={{ borderRadius: '50%' }}
                    />
                  </div>
                  <div className="similar-blog-info">
                    <div className="similar-blog-title">{job.title}</div>
                    <div className="similar-blog-author">{job.company} • {job.location}</div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className="similar-blog-block">
                  <div className="similar-blog-image-wrapper">
                    <img className="similar-blog-image" src="/favicon.svg" alt="Job" loading="lazy" style={{ borderRadius: '50%' }} />
                  </div>
                  <div className="similar-blog-info">
                    <div className="similar-blog-title">Senior Interior Designer</div>
                    <div className="similar-blog-author">NYC • Full-time</div>
                  </div>
                </div>
                <div className="similar-blog-block">
                  <div className="similar-blog-image-wrapper">
                    <img className="similar-blog-image" src="/favicon.svg" alt="Job" loading="lazy" style={{ borderRadius: '50%' }} />
                  </div>
                  <div className="similar-blog-info">
                    <div className="similar-blog-title">Furniture Designer (Remote)</div>
                    <div className="similar-blog-author">Remote • Contract</div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        {/* Staff-Picked Designers Section */}
        <div className="blog-previews-section" style={{ borderTop: '1px solid #e5e7eb', paddingTop: '16px', marginTop: '24px' }}>
          <h3 className="blog-previews-title">Top Designers</h3>
          <div className="similar-blogs-list">
            {staffPickedDesigners.map(designer => (
              <div
                key={designer.id}
                className="similar-blog-block"
                onClick={() => navigate(`/profile/${designer.username}`)}
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}
              >
                <div className="similar-blog-image-wrapper" style={{ 
                  width: '48px', 
                  height: '48px', 
                  borderRadius: '50%', 
                  overflow: 'hidden',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  flexShrink: 0
                }}>
                  <img
                    className="similar-blog-image"
                    src={designer.avatar}
                    alt={designer.name}
                    loading="lazy"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  />
                </div>
                <div className="similar-blog-info" style={{ flex: 1 }}>
                  <div className="similar-blog-title" style={{ fontWeight: '600', fontSize: '14px', color: '#1F1937' }}>{designer.name}</div>
                  <div className="similar-blog-author" style={{ fontSize: '12px', color: '#6b7280' }}>{designer.description}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <PostingModal
        isOpen={showPostModal}
        onClose={() => { 
          setShowPostModal(false); 
          setPostingModalAction(null);
          setCreatePostContent('');
          setCreatePostMedia([]);
        }}
        onPost={(newPost) => {
          handleAddPost(newPost);
          setCreatePostContent('');
          setCreatePostMedia([]);
        }}
        action={postingModalAction}
        prefilledContent={createPostContent}
        prefilledMedia={createPostMedia}
      />
      
      {/* Delete Confirmation Modal */}
      <Modal 
        isOpen={showDeleteModal} 
        onClose={() => setShowDeleteModal(false)}
        title="Delete Post"
        className="delete-post-modal"
      >
          <p style={{ margin: '0 0 24px 0', fontSize: '15px', color: '#4b5563' }}>
            Are you sure you want to delete this post? This action cannot be undone.
          </p>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <Button 
              backgroundColor="#f3f4f6" 
              color="#374151"
              onClick={() => setShowDeleteModal(false)}
              width="90px"
              height="40px"
              borderRadius="8px"
            >
              Cancel
            </Button>
            <Button 
              backgroundColor="#EF4444" 
              color="white"
              onClick={handleDeletePost}
              width="90px"
              height="40px"
              borderRadius="8px"
            >
              Delete
            </Button>
          </div>
      </Modal>

      {/* Comment Modal */}
      {/* No global comment modal, handled per post */}
    </div>
  );
};

export default FeedScreen;


